import { createContext } from "react";

interface ToggleProviderProds {
  onMobileSearchOpen: () => void,
}

export const HeaderToggleContext = createContext<ToggleProviderProds | null>(null);
